import Client from 'config/axios';
import posthog from 'posthog-js';

export const deactiveBonusByGroup = async (token: string, groupId: any) => {
  const { data } = await Client.post(
    `deactivate-allow-bonus-by-group/${groupId}`,
    null,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  posthog.capture('DeactiveBonusByGroup', {
    DeactiveBonusByGroup: data
  });
  return {
    data
  };
};
